import Model from '@/models/Model.js';

export default class Timeline extends Model {
    static entity = 'timelines';

    static fields() {
        return {
            id: this.attr(null),
            external_id: this.attr(null),
            timeline_category_id: this.attr(null),
            is_featured: this.attr(null),
            title: this.string(''),
            description: this.string(null, value => (value === 'null' ? null : value)),
            timelineable_type: this.attr(null),
            timelineable_id: this.attr(null),

            ...super.fields(),

            timeline_category: this.belongsTo('timeline_categories', 'timeline_category_id'),

            timeline_checkpoints: this.hasMany('timeline_checkpoints', 'timeline_id'),
        };
    }
}
